
import { ICommand } from "../../modules/records/commands/i-command";
import { IApiService } from "../../modules/records/models/api/i-api-service";
import { RecordsManager } from "../../modules/records/records-manager";
import { InterviewDetailV2Component } from "../modals/interview-detail-v2/interview-detail-v2.component";

export class OpenInterviewDetailCommand<T extends object>
  implements ICommand<T, IApiService<T>>
{
  private receiver!: RecordsManager<T>;
  execute(el: T) {
    this.receiver.showDialog(InterviewDetailV2Component, {
      data: el,
      maxWidth: "100vw",
      maxHeight: "100vh",
      panelClass: "interviewDetailDialogContainer",
    });
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  isDisabled(el: T) {
    return this.receiver.isLoading;
  }
}
